import React, { Suspense, useState } from "react";
import { Outlet } from "react-router-dom";
import { MainLoader, SideNav, TopNav } from "../../CommonComponent";

const DashboardLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  return (
    <div
      className={`screen-area ${
        isSidebarOpen ? "sidebar-open" : "sidebar-closed"
      }`}
    >
      <TopNav />
      <div className="d-flex">
        <SideNav isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <div className="content-area">
          <Suspense fallback={<div>Loading...</div>}>
            <Outlet />
          </Suspense>
        </div>
      </div>
      <MainLoader/>
    </div>
  );
};

export default DashboardLayout;
